import { render } from "./BaseCheckboxGroup.vue?vue&type=template&id=d32a3754"
import script from "./BaseCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-client/megaluzz-client/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__